import { useState } from 'react'

import { DataClass, DataItem } from 'scrivito'

import { dataScopeHasMore } from '@/utils/dataScopeHasMore'

/**
 * custom hook to fetch the index from a DataClass
 * @param dataClass
 * @param transform filter object to pass the search parameters
 * @returns
 */
export const useDataClassIndex = (
  dataClass: DataClass,
  transform: object = {},
  initialLimit: number = 20,
) => {
  const [limit, setLimit] = useState(initialLimit)
  let dataItems: DataItem[] = []
  let count: number = 0

  try {
    const scope = dataClass.all().transform({
      ...transform,
      limit,
    })

    dataItems = scope.take()
    count = scope.count() ?? 0
  } catch (error) {
    reportError(error)
  }

  const hasMore = dataScopeHasMore(dataClass.all(), transform, limit)

  const loadMore = () => {
    setLimit((prev) => prev + 10)
  }

  return { dataItems, hasMore, loadMore, count }
}
